import {useEffect} from 'react'
import PageHeader from "./PageHeader";
import {useAppDispatch} from '../redux/Hooks'
import {setPage} from '../redux/User/UserSlice'

export default function ConditionsOfUse() {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setPage('conditionOfUse'))
    }, [dispatch])

    return <>
        <PageHeader
            title="Conditions générales d’utilisation de la plateforme Instances de Transitions Pro Île-de-France"
            breadcrumb/>
        <div className="container">
            <div className="block">
                <p>Nous vous remercions d'utiliser l’outil Instances Transitions Pro IDF.<br/>
                    L’accès à l’outil et son utilisation sont soumis aux présentes conditions générales, et à toutes
                    modifications qui pourront y être apportées ultérieurement (ci-après « les conditions »).<br/>
                    En accédant à l'outil et en l’utilisant, l’utilisateur accepte de façon inconditionnelle d’être lié
                    par
                    les conditions, à l’exclusion de toutes autres conditions.</p>
                <h2>ARTICLE 1 – SERVICE PROPOSÉ</h2>
                <ol>
                    <li>L’outil Instances Transitions Pro IDF (ci-après « l’outil ») est un outil qui est destiné aux
                        administrateurs et aux commissaires de Transitions Pro IDF et qui devra centraliser les éléments
                        et
                        outils nécessaires et utiles pour que les commissaires-administrateurs puissent assumer et
                        assurer au
                        mieux leurs mandats.
                    </li>
                    <li>L'outil est accessible depuis toute connexion Internet via l’interface web.</li>
                </ol>

                <h2>ARTICLE 2 – CONDITIONS D’ACCÈS DU SERVICE</h2>
                <ol>

                    <li>L'outil est accessible aux personnes physiques</li>
                    <li>Pour accéder à l'outil, l’utilisateur doit se connecter après que l’administrateur de l’outil
                        lui ait
                        créé un compte en communiquant prénom, courriel (qui servira d’identifiant), Civilité, Photo,
                        Adresse,
                        Téléphones, le Collège, l’Organisation syndicale<br/>
                        La Société se réserve le droit de soumettre l’accès à des conditions supplémentaires, sans
                        indication de
                        motif.
                    </li>
                    <li>Un seul compte est autorisé par utilisateur. Chaque utilisateur est entièrement et exclusivement
                        responsable de l’accès et de toute activité effectuée sur l'outil au moyen de ses identifiants.
                        L’utilisateur veille à ce qu’aucune autre personne n’ait accès à l'outil au moyen de ses
                        identifiants et
                        veille à se déconnecter de l’outil à la fin de chaque session. Dans l’hypothèse où l’utilisateur
                        aurait
                        connaissance d’une utilisation illicite de ses identifiants, il doit en informer Transitions Pro
                        IDF
                        sans délai en utilisant le formulaire de contact présent sur le site
                    </li>
                    <li>Après 1 an sans mandat, le compte créé est supprimé.</li>
                </ol>

                <h2>ARTICLE 3 – CONDITIONS D’UTILISATION DU SERVICE</h2>
                <ol>
                    <li>L’outil est mis à disposition des utilisateurs sans contrepartie financière</li>
                    <li>L’outil est mis à disposition uniquement pendant la durée du mandat des utilisateurs. Un
                        utilisateur
                        mettant fin à son mandat, ou dont le mandat ne serait pas renouvelé n’aura plus accès à l’outil
                    </li>
                    <li>Un utilisateur qui aurait une interruption de mandat pendant un an ou plus et qui serait à
                        nouveau
                        mandaté aura un nouveau compte et donc ne pourra pas voir l’historique de son ancien compte qui
                        aura été
                        supprimé entre temps.
                    </li>
                </ol>
                <h2>ARTICLE 4 – RÉSILIATION, SUSPENSION OU REFUS DE L’ACCÈS</h2>
                <ol>
                    <li>Transitions Pro IDF se réserve le droit de suspendre, limiter, supprimer ou refuser l’accès à
                        l'outil
                        à tout utilisateur qui ne respecterait pas les Conditions d’Utilisation.
                    </li>
                    <li>Transitions Pro IDF se réserve le droit d’interrompre à tout moment et sans avis préalable,
                        l’accès à
                        l'outil afin d’effectuer des opérations de maintenance ou d’apporter des modifications ou
                        améliorations
                        à l'outil.
                    </li>
                    <li>L’utilisateur est libre de demander, à tout moment, à ce que son compte soit supprimé, en en
                        faisant
                        la demande depuis le formulaire de contact.
                    </li>
                </ol>
                <h2>ARTICLE 5 – RESPONSABILITÉ ET INDEMNISATION</h2>
                <ol>
                    <li>La Société Rich ID, développeur et hébergeur de la solution, ainsi que Transitions Pro
                        Île-de-France,
                        ne peuvent garantir la disponibilité continue, sécurisée et exempte d’erreur de l'outil et de
                        toutes les
                        fonctions de l'outil, ni l'absence de virus ou de tout autre élément dommageable sur
                        l'outil.<br/>
                        L’utilisateur est seul responsable de son matériel informatique, de ses logiciels et de son
                        accès à
                        Internet.<br/>
                        La Société Rich ID et Transitions Pro IDF, et se réservent par ailleurs le droit d’interrompre à
                        tout
                        moment et sans avis préalable, l’accès à l'outil afin d’effectuer des opérations de maintenance
                        ou
                        d’apporter des modifications ou améliorations à l'outil.
                    </li>
                    <li>Aucune garantie n’est offerte par Transitions Pro IDF, en cas de perte ou de défaut de
                        conservation
                        de tout contenu sur l'outil.
                    </li>
                    <li>Transitions Pro IDF n’est responsable d’aucune perte ou dommage que l’utilisateur aurait subi à
                        la
                        suite de l’utilisation non autorisée de ses identifiants par autrui, et ce, même si
                        l’utilisateur en
                        ignorait l’utilisation.
                    </li>
                    <li>Transitions Pro IDF ne pourra en aucun cas être tenue responsable de tout dommage, direct ou
                        indirect
                        (incluant la perte de profits et la perte d’opportunité), subi par l’utilisateur, en lien avec
                        l’utilisation de l'outil, son Contenu ou en raison de l’impossibilité d’utiliser l'outil.
                    </li>
                </ol>

                <h2>ARTICLE 6 – PROTECTION DE LA VIE PRIVÉE</h2>
                <p>Transitions Pro IDF agissant en qualité de responsable de traitement, est amené à traiter les données
                    personnelles saisie dans l’outil Instances, ainsi que dans le cadre à la maintenance de l’outil
                    Instances, dans le cadre de l’évolution des fonctionnalités de l’outil Instances, pour gérer les
                    demandes d’assistance et afin de préserver la sécurité des données.</p>

                <p>a. La finalité du traitement est : L’hébergement des données personnelles contenues dans l’outil Instances</p>
                <p>b. La nature des opérations réalisées sur les données est : Hébergement, accès, modification,
                conservation, collecte, enregistrement, organisation, conservation, adaptation, modification,
                extraction, consultation, utilisation, communication par transmission ou diffusion ou toute autre forme
                    de mise à disposition, rapprochement.</p>
                <p>c. Les données à caractère personnel traitées sont : Les données d’identification (nom, prénom, etc.),
                les données professionnelles (courriel, fonction, etc.) et les données de connexion (logs de connexion,
                    préférences de profil…).</p>
                <p>d. Les catégories de personnes concernées sont : Les personnes sous l’autorité de <span className="text-danger">XXXXX</span></p>
                <p className="text-danger">e. Destinataires / Sous-traitance :</p>
                <ol>
                    <li className="text-danger">Transfert hors UE :</li>
                </ol>
                <p >f. Description des mesures de sécurité en place</p>
                <ol>
                    <li className="text-danger">...</li>
                </ol>

                <p>Conformément à la règlementation vous bénéficiez d’un droit d’accès, de rectification, d’effacement de
                vos données et d’opposition. Pour toute demande d’exercice de droit et d’information relative à la
                protection des données, vous pouvez écrire à : <a href="mailto:dpo@transitionspro-idf.fr">dpo@transitionspro-idf.fr</a><br/>
                L’Utilisateur est seul responsable des usages et seul garant de la confidentialité de ses identifiants
                (adresse électronique et mot de passe), ainsi que de toute utilisation du Compte.</p>

                <p>L’Utilisateur s’engage à informer immédiatement XXXXX de toute utilisation non autorisée du Compte, et
                de toute atteinte à la confidentialité et à la sécurité de ses moyens d’identification via l’adresse
                électronique suivante : « <span className="text-danger">XXXXX</span> ».</p>

                <p>Si Transitions Pro IDF a des motifs sérieux et objectifs de penser que la sécurité de l’outil Instances
                est violé, ou qu’il existe une utilisation non autorisée des moyens d’identification de l’Utilisateur,
                alors Transitions Pro IDF pourra, après suspension du Compte, exiger la modification de ces moyens
                d’identification, afin notamment de préserver l’intégrité de l’outil Instances.</p>

                <p>Le non-respect de ces conditions entrainera l’application des sanctions prévues sous les sections « <span className="text-danger">xx
                    Suspension temporaire</span> » et « <span className="text-danger">xx Suppression définitive</span> » des présentes CGU.</p>

                <h2>ARTICLE 7 – MODIFICATION DES CONDITIONS ET DE L’OUTIL</h2>
                <ol>
                    <li>La Société Rich ID se réserve le droit de modifier et de mettre à jour à tout moment, et sans
                        préavis, les Conditions et/ou l'outil. En cas de modification substantielle des Conditions, une
                        notification sera publiée sur l'outil. En continuant à accéder à l'outil ou à l’utiliser après
                        la
                        notification, l’utilisateur marque son accord sur les Conditions ainsi modifiées.
                    </li>
                    <li>L’utilisateur est tenu de prendre connaissance des Conditions et de vérifier périodiquement
                        qu’elles
                        n’ont pas été modifiées. L’utilisateur peut consulter la plus récente version des Conditions à
                        tout
                        moment sur l'outil.
                    </li>
                    <li>La Société Rich ID se réserve le droit, à tout moment, de manière définitive ou temporaire,
                        d’arrêter
                        de fournir tout ou partie des services ou fonctionnalités de l'outil.
                    </li>
                </ol>
                <h2>ARTICLE 8 – DIVERS</h2>
                <ol>
                    <li>La nullité, la caducité ou le caractère non exécutoire de tout ou partie d'une des dispositions
                        des
                        Conditions n’affectera pas la validité ni l’efficacité des autres dispositions des Conditions.
                    </li>
                    <li>Le fait pour Transitions Pro IDF de ne pas se prévaloir, à un moment donné, d’une disposition
                        des
                        Conditions ou d’un droit, ne pourra être interprété comme une renonciation à faire valoir
                        ultérieurement
                        cette même disposition ou droit.
                    </li>
                </ol>

                <h2>ARTICLE 9 – LOI APPLICABLE ET COMPÉTENCE DE JURIDICTION</h2>
                <ol>
                    <li>Toute contestation qui résulterait de l'utilisation de l'outil sera soumise aux cours et
                        tribunaux de
                        Paris (France), sous réserve des cas où les tribunaux compétents sont désignés par des
                        dispositions
                        légales ou réglementaires.
                    </li>
                    <li>En cas de litige, l’utilisateur accepte que la production des données relatives à l’utilisation
                        de
                        l'outil, enregistrées sur les serveurs de l'outil, puisse faire foi entre les parties au litige.
                    </li>
                </ol>

                <h2>ARTICLE 10 – ENTREE EN VIGUEUR</h2>

                <p>Les présentes Conditions générales sont applicables à compter de la date de leur acceptation par
                    l’utilisateur lors de l'activation de son espace personnel et jusqu’à la date de suppression de son
                    accès.</p>


            </div>
        </div>
    </>
}
